import { withTheme } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import * as lib from '~/dependencies';

export const DialogContainer = lib.styled(Dialog)`
  /* margin-bottom: 30px; */
  [class*='MuiPaper-elevation24'] {
    box-shadow: none;
  }
`;

export const DialogContext = withTheme(lib.styled.div`
  width: 400px;
  height: 657px;
  background-color: ${props => props.theme.palette.background.paper};
  outline: none;
`);
